import { isFree, isRentEnabled, isSaleEnabled, isBought, isRented } from 'shared/ui-selectors/video/pricing';
import { isSubscriptionEnabled } from 'shared/ui-selectors/channel/pricing';
import { previewTypes } from 'shared/constants/preview-types';
import { hasTrailer, getPreviewType } from 'shared/ui-selectors/video/preview';
import { canAccessChannelWithSubscription } from './channel-access';


function isLoggedIn(currentSiteUser) {
  return !_.isEmpty(currentSiteUser);
}

export function isForMemberOnly(video) {
  return Boolean(video.memberOnly);
}

export function canAccessFullVideo(channel, video, currentSiteUser) {
  return isFree(video) && (!isForMemberOnly(video) || isLoggedIn(currentSiteUser)) ||
    isRented(video) ||
    isBought(video) ||
    canAccessChannelWithSubscription(channel);
}

// What user need to do to get access to full video
export const FULL_ACCESS_ACTION_NAMES = {
  SIGN_IN: 'needs-sign-in',
  SUBSCRIBE: 'needs-subscription',
  BUY: 'need-to-buy',
  RENT: 'need-to-rent',
  BUY_OR_RENT: 'need-to-buy-or-rent',
};

export function getFullAccessActionName(channel, video, currentSiteUser) {
  if (canAccessFullVideo(channel, video, currentSiteUser)) {
    return null;
  }

  if (isFree(video) && isForMemberOnly(video)) {
    return FULL_ACCESS_ACTION_NAMES.SIGN_IN;
  }

  if (isSubscriptionEnabled(channel) && channel.subscriptionOnly) {
    return FULL_ACCESS_ACTION_NAMES.SUBSCRIBE;
  }

  if (isRentEnabled(video) && isSaleEnabled(video)) {
    return FULL_ACCESS_ACTION_NAMES.BUY_OR_RENT;
  }

  if (isRentEnabled(video)) {
    return FULL_ACCESS_ACTION_NAMES.RENT;
  }

  if (isSaleEnabled(video)) {
    return FULL_ACCESS_ACTION_NAMES.BUY;
  }
}


export const AVAILABLE_VIDEO_TYPES = {
  FULL: 'full-video',
  TRAILER: 'trailer',
  FIRST_20_SEC: 'preview',
};

export function getAvailableVideoType(channel, video, currentSiteUser) {
  if (canAccessFullVideo(channel, video, currentSiteUser)) {
    return AVAILABLE_VIDEO_TYPES.FULL;
  }

  if (isFree(video) && isForMemberOnly(video)) {
    return;
  }

  const previewType = getPreviewType(video);
  if (hasTrailer(video) && previewType === previewTypes.TRAILER) {
    return AVAILABLE_VIDEO_TYPES.TRAILER;
  }

  if (previewType === previewTypes.FIRST_20_SEC) {
    return AVAILABLE_VIDEO_TYPES.FIRST_20_SEC;
  }
}

export function canPlayFullOrPreview(channel, video, currentSiteUser) {
  return Boolean(getAvailableVideoType(channel, video, currentSiteUser));
}



// WEBPACK FOOTER //
// ./src/widget/ui-selectors/video-access.js